//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import util from '@/libs/util.js';
import VueUeditorWrap from 'vue-ueditor-wrap';
// import '../../../static/wwei_editor.css';
import '../../../src/styles/wwei_editor.css';
import fileUploader from '@/views/common-components/file-uploader.vue';
import skuEditor from '@/views/common-components/sku-editor.vue';
// import selectBrandModal from '@/views/common-components/select-brand-modal.vue';
import selectShopModal from './components/select-shop-modal';
import SelectCouponModal from '../coupons/components/select-coupon-modal';

export default {
    name: 'goodEdit',
    components: {
        SelectCouponModal,
        VueUeditorWrap,
        fileUploader,
        skuEditor,
        // selectBrandModal,
        selectShopModal
    },
    data() {
        const vm = this;
        return {
            loading: false,
            saving: false,
            current: 0,
            goodId: 0,
            goodType: 'GoodLogo',
            goodPictureType: 'GoodPicture',
            good: {
                goodGroupIds: []
            },
            groupList: [],
            goodRules: {
                goodName: { required: true, message: '请输入商品名称', trigger: 'blur' },
                shopName: { required: true, message: '请输选择店铺', trigger: 'blur' },
                couponName: { required: true, message: '请输选择优惠券', trigger: 'blur' },
                goodType: { required: true, type: 'number', message: '请输商品类别', trigger: 'change' }
            },
            showAddBrandModal: false,
            editorConfig: {
                UEDITOR_HOME_URL: '/UEditor/'
            },
            fUeditor: null,
            vEditor: null,
            cUeditor: null,
            currentStyle0: {
                display: 'block'
            },
            currentStyle1: {
                display: 'none'
            },
            currentStyle2: {
                display: 'none'
            },
            currentStyle3: {
                display: 'none'
            },
            currentStyle4: {
                display: 'none'
            },
            spec: {},
            specData: [],
            specificationList: [],
            specEditableColumns: [{
                key: 'linePrice',
                title: '划线价'
            },
                {
                    key: 'price',
                    title: '价格'
                },
                {
                    key: 'inventory',
                    title: '库存'
                }
            ],
            goodTypes: [
                {
                    id: 0,
                    value: '实物商品'
                },
                {
                    id: 1,
                    value: '卡券商品'
                }
                // {
                //     id: 2,
                //     value: '预约服务'
                // }
            ],
            finance: {
                content: ''
            },
            vehicle: {
                content: ''
            },
            carBuying: {
                content: ''
            },
            financeType: 'good.content',
            vehicleType: 'good.vehicle',
            carBuyingType: 'good.carBuying',
            isShow: false,
            isNumber: true,
            showAddShopModal: false,
            showSelectCouponModel: false
            // goodContentType: 'good.content'
        };
    },
    methods: {
        showCurrent(current) {
            if (current == 0) {
                this.currentStyle0.display = 'block';
                this.currentStyle1.display = 'none';
                this.currentStyle2.display = 'none';
                this.currentStyle3.display = 'none';
                this.currentStyle4.display = 'none';
            }
            if (current == 1) {
                this.currentStyle0.display = 'none';
                this.currentStyle1.display = 'block';
                this.currentStyle2.display = 'none';
                this.currentStyle3.display = 'none';
                this.currentStyle4.display = 'none';
            }
            if (current == 2) {
                this.currentStyle0.display = 'none';
                this.currentStyle1.display = 'none';
                this.currentStyle2.display = 'block';
                this.currentStyle3.display = 'none';
                this.currentStyle4.display = 'none';
            }
            if (current == 3) {
                this.currentStyle0.display = 'none';
                this.currentStyle1.display = 'none';
                this.currentStyle2.display = 'none';
                this.currentStyle3.display = 'block';
                this.currentStyle4.display = 'none';
            }
            if (current == 4) {
                this.currentStyle0.display = 'none';
                this.currentStyle1.display = 'none';
                this.currentStyle2.display = 'none';
                this.currentStyle3.display = 'none';
                this.currentStyle4.display = 'block';
            }
        },
        fEditorReady(editor) {
            this.fUeditor = editor;
            this.finance = {
                content: ''
            };
        },
        vEditorReady(editor) {
            this.vUeditor = editor;
        },
        cEditorReady(editor) {
            this.cUeditor = editor;
        },
        specDataChange: function(newData) {
            this.specificationList = JSON.parse(JSON.stringify(newData));
        },
        // getGoodGroupList() {
        //     this.$store.dispatch({
        //         type: 'good/getGoodGroupList'
        //     }).then(() => {
        //         this.groupList = this.$store.state.good.goodGroupList;
        //     }).finally(() => {
        //     });
        // },
        getGood() {
            this.loading = true;
            this.$store
                .dispatch({
                    type: 'good/getGoodById',
                    id: this.goodId
                })
                .then(() => {
                    this.good = this.$store.state.good.goodInfo;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        delete(good) {
            this.$store
                .dispatch({
                    type: 'good/delGood',
                    id: good.id
                })
                .then(() => {
                    this.$Notice.success({
                        duration: 3,
                        title: good.name + '已删除'
                    });
                    this.getPage();
                });
        },
        delGood(good) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '您确定要删除' + good.goodName + '吗？',
                onOk: () => {
                    this.delete(good);
                },
                onCancel: () => {
                }
            });
        },
        // showAddBrand() {
        //     this.showAddBrandModal = true;
        // },
        // addBrand(brand) {
        //     this.good.brandName = brand.name;
        //     this.good.brandId = brand.id;
        //     this.showAddBrandModal = false;
        // },
        showAddShop() {
            this.showAddShopModal = true;
        },
        addShop(shop) {
            this.good.shopName = shop.name;
            this.good.shopId = shop.id;
            this.good.shopType = shop.shopType;
            this.showAddShopModal = false;
        },
        showGoodInfo() {
            this.getGood();
            this.current = 0;
            this.showCurrent(this.current);
        },
        saveGood() {
            console.log(this.good);
            this.good.isHaveSpecData = this.isShow;
            this.$refs.goodForm.validate(async val => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Good/SaveGood', this.good).then(
                        resp => {
                            this.goodId = resp.data.result;
                            this.good.id = resp.data.result;
                            this.current = 1;
                            this.showCurrent(this.current);
                            this.getGoodSpecificationList();
                        },
                        () => {
                        }
                    ).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        getGoodSpecificationList() {
            this.loading = true;
            this.spec = {};
            var targetSpec = {};
            abp.ajax.get('/api/services/app/GoodSpecification/GetGoodSpecifiction?goodId=' + this.goodId).then(resp => {
                var gs = resp.data.result;
                gs.goodAttributes.map((item, index) => {
                    var children = item.goodAttributeDetials.map((child, index) => {
                        return {
                            id: child.id,
                            parentId: item.id,
                            text: child.name
                        };
                    });
                    targetSpec[item.name] = children;
                });

                this.spec = targetSpec;
                this.specData = gs.goodSpecifications.map((item, index) => {
                    return {
                        id: item.goodAttributeDetailId,
                        linePrice: item.linePrice,
                        price: item.price,
                        inventory: item.inventory
                    };
                });
                if (this.specData.length > 0) {
                    this.isShow = true;
                } else {
                    this.isShow = false;
                }
            })
                .finally(() => {
                    this.loading = false;
                });
        },
        saveGoodAttribute(name) {
            this.saving = true;
            return new Promise((resolve, reject) => {
                abp.ajax.post('/api/services/app/GoodSpecification/SaveGoodAttribute', {
                    name: name,
                    goodId: this.goodId
                }).then(
                    resp => {
                        resolve(resp.data.result);
                        this.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                    },
                    () => {
                        reject();
                    }
                ).finally(() => {
                    this.saving = false;
                });
            });
        },
        saveGoodAttributeDetail(gaName, name) {
            this.saving = true;
            return new Promise((resolve, reject) => {
                abp.ajax.post('/api/services/app/GoodSpecification/SaveGoodAttributeDetail', {
                    name: name,
                    goodId: this.goodId,
                    goodAttributeName: gaName
                }).then(
                    resp => {
                        resolve(resp.data.result);
                        this.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                    },
                    () => {
                        reject();
                    }
                ).finally(() => {
                    this.saving = false;
                });
            });
        },
        saveSpecification() {
            var isValue = false;
            let minPrice = 0;
            let linePrice = 0;
            let totalInventory = 0;
            if (this.specificationList.length > 0) {
                for (var i = 0; i < this.specificationList.length; i++) {
                    if (this.specificationList[i].goodAttributeDetailId == 0) {
                        isValue = true;
                    }
                    this.specificationList[i].goodId = this.goodId;
                    this.specificationList[i].goodAttributeDetailId = this.specificationList[i].id;
                    this.specificationList[i].id = 0;
                    // this.specificationList[i].price = parseInt(this.specificationList[i].price * 100);
                    // this.specificationList[i].linePrice = parseInt(this.specificationList[i].linePrice * 100);
                    if (minPrice == 0) {
                        minPrice = this.specificationList[i].price;
                        linePrice = this.specificationList[i].linePrice;
                    } else {
                        if (minPrice > this.specificationList[i].price) {
                            minPrice = this.specificationList[i].price;
                            linePrice = this.specificationList[i].linePrice;
                        }
                    }
                    totalInventory = totalInventory + this.specificationList[i].inventory;
                }
            }

            if (isValue == false) {
                if (this.specificationList.length > 0) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/GoodSpecification/SaveSpecification', this.specificationList).then(resp => {
                            let gd = {
                                id: this.goodId,
                                price: minPrice,
                                linePrice: linePrice,
                                totalInventory: totalInventory
                            };
                            abp.ajax.put('/api/services/app/Good/UpdateGoodPrice', gd).then(resp => {
                                    this.current = 2;
                                    this.showCurrent(this.current);
                                    this.getGraphicInformation(this.financeType);
                                    this.loading = false;
                                }, () => {
                                }
                            );
                        }, () => {
                        }
                    ).finally(() => {
                        this.saving = false;
                    });
                } else {
                    this.current = 2;
                    this.showCurrent(this.current);
                    this.getGraphicInformation(this.financeType);
                }
            }
        },
        getSpecifications() {
            this.getGoodSpecificationList();
            this.current = 1;
            this.showCurrent(this.current);
        },
        getGraphicInformation(businessType) {
            this.loading = true;
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + this.goodId +
                '&businessType=' + businessType).then(resp => {
                let business = {};
                if (resp.data.result != null) {
                    business = resp.data.result;
                } else {
                    this.finance = {
                        id: 0,
                        content: '',
                        businessType: this.financeType
                    };
                    this.vehicle = {
                        id: 0,
                        content: '',
                        businessType: this.vehicleType
                    };
                    this.carBuying = {
                        id: 0,
                        content: '',
                        businessType: this.carBuyingType
                    };
                }
                if (businessType == this.financeType) {
                    if (business.id != undefined) {
                        this.finance = JSON.parse(JSON.stringify(business));
                    }
                    this.current = 2;
                }
                if (businessType == this.vehicleType) {
                    if (business.id != undefined) {
                        this.vehicle = JSON.parse(JSON.stringify(business));
                    }
                    this.current = 3;
                }
                if (businessType == this.carBuyingType) {
                    if (business.id != undefined) {
                        this.carBuying = JSON.parse(JSON.stringify(business));
                    }
                    this.current = 4;
                }
                this.showCurrent(this.current);
            })
                .finally(() => {
                    this.loading = false;
                });
        },
        saveGraphicInformation(business, businessType) {
            business.businessId = this.goodId;
            this.saving = true;
            abp.ajax.post('/api/services/app/GraphicInformation/SaveGraphicInformationByBussin', business)
                .then(
                    resp => {
                        if (businessType != undefined) {
                            this.getGraphicInformation(businessType);
                        } else {
                            this.$router.push({
                                path: '/shop/goodList/'
                                // name: 'goodList'
                            });
                        }
                    },
                    () => {
                    }
                ).finally(() => {
                this.saving = false;
            });
        },
        showAddACoupon() {
            this.showSelectCouponModel = true;
        },
        addCoupon(data) {
            // console.log(data);
            this.good.couponName = data.name;
            this.good.couponId = data.id;
            this.showSelectCouponModel = false;
        }
    },
    created() {
        console.log('编辑商品');
        // this.getGoodGroupList();
        this.goodId = parseInt(this.$route.params.id || 0);
        if (this.goodId != 0) {
            this.getGood();
            this.getGoodSpecificationList();
        }
    },
    computed: {},
    mounted() {
    },
    watch: {
        '$route'(to, from) {
            // data数据操作
            if (to.name === 'goodEdit') {
                this.goodId = parseInt(this.$route.params.id || 0);
                this.good = {};
                this.spec = {};
                if (this.goodId != 0) {
                    this.getGood();
                    this.getGoodSpecificationList();
                }
                this.current = 0;
                this.showCurrent(this.current);
            }
        }
        // $route: {
        //     handler: function (val, oldVal) {
        //         this.current = 0;
        //         this.isShow = false;
        //         this.goodId = parseInt(this.$route.params.id || 0);
        //         this.currentStyle0.display = "block";
        //         this.currentStyle1.display = "none";
        //         this.currentStyle2.display = "none";
        //         this.currentStyle3.display = "none";
        //         this.currentStyle4.display = "none";
        //         if (this.goodId != 0) {
        //             this.getGood();
        //             this.getGoodSpecificationList();
        //         } else {
        //             this.good = {};
        //         }
        //     },
        //     deep: true
        // }
    }
};
